import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { userActions } from '../redux/userState';
import { alertActions } from '../redux/AlertController';


const useLogin = () => {
    const [loading,setLoading] = useState(false);
    const dispatch = useDispatch()

    const login = async (username,password)=>{
        setLoading(true)
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/owner/login`,{
                method:'POST',
                body: JSON.stringify({username,password}),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            const json = await res.json();

            if(res.ok){
                localStorage.setItem('token',JSON.stringify(json.token))
                localStorage.setItem('user', JSON.stringify(json))
                dispatch(alertActions.showAlert({msg:'تم الدخول بنجاح',type:'success'}))
                dispatch(userActions.setUserData(json))
                return true
            }else {
                dispatch(alertActions.showAlert({msg:json.message,type:'error'}));
                return false
            }
        }catch(err){
            dispatch(alertActions.showAlert({msg:err.message,type:'error'}));
            return false
        } finally {
            setLoading(false)
        }
    }

    const getSession = async ()=>{
        const token = JSON.parse(localStorage.getItem('token'))

        if (token) {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/owner/session`,{
                    method:'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                })
                const json = await res.json();
    
                if(res.ok){
                    const userData = { ...json, token }
                    localStorage.setItem('user',JSON.stringify(userData))
                    dispatch(userActions.setUserData(userData))
                }else {
                    localStorage.clear()
                }
            }catch(err){
                localStorage.clear()
            }
        }

    }

    return {loading,login,getSession}
}

export default useLogin